import HttpWrapper from '@/utils/http/httpWrapper'
import ShipbobAppSettings from '@/appSettings/appSetting'
const ORDERS_STATE_API = ShipbobAppSettings.ordersStateApi

class WorkOrdersServiceInternal {
  urls () {
    return {
      onHold: `${ORDERS_STATE_API}/api/onholdstate`
    }
  }

  async fetchOnHoldReasons () {
    const request = {
      Url: this.urls().onHold
    }
    return await HttpWrapper.Get(request)
  }
}

export const WorkOrdersService = new WorkOrdersServiceInternal()
